<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="container-fluid content-container">
  
  <div class="content-container">
    <app-carousel
      *ngIf="helperService.user.role.roleId === 4"
      class="carousel"
      [recievedArray]="Workshop"
      (brand)="setClickedBrand($event)"
    ></app-carousel>

    <mat-card>
      <mat-card class="Info-Advisor">
        <mat-card-content>
          <div class="header-containerw">
           
            <div class="header-controlsw">
              <button
                mat-button
                *ngFor="let control of controls"
                (click)="onEditInformationClick()"
              >
             <i [ngClass]="control.icon"
                  >&nbsp; &nbsp;{{ "NewAdvisor" | translate }}</i
                >
              </button>
            </div>
          </div>
        </mat-card-content>

        <mat-card class="advisor-grid-container">
          <ng-template  #loading >
              <div class="loading-containerAdvisor">
              <section>
                <div  class="pulsing">
                  <mat-spinner [diameter]="50" ></mat-spinner>
                </div>
                <p class="pulsing">{{"Loading" | translate}}</p>
              </section>
            </div>
           
          </ng-template>
          <div class="row" *ngIf="modalInformation$ | async as modalData;else loading" >
            <div class="col">
              <table class="table table-striped" style="width: 100%">
                <thead>
                  <tr class="advisor-grid-headers">
                    <th scope="col">{{ "AdvisorName" | translate }}</th>
                    <th scope="col">{{ "State" | translate }}</th>
                    <th
                      scope="col"
                      *ngIf="helperService.user.role.roleId === 4"
                    >
                      {{ "Workshop" | translate }}
                    </th>
                    <th scope="col">{{ "Brand" | translate }}</th>
                    <th scope="col">{{ "TypeOfService" | translate }}</th>
                    <th scope="col">{{ "Actions" | translate }}</th>
                  </tr>

                  <tr class="advisor-grid-inputs">
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            [(ngModel)]="FilterByName"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                    <th scope="col"></th>
                   
                    <th
                      scope="col"
                      *ngIf="helperService.user.role.roleId === 4"
                    >
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                              matInput
                              type="text"
                              [(ngModel)]="FilterByWorkshop"
                            />
                          </mat-form-field>
                          
                        </div>

                    </th>
                    <th scope="col">
                 
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                              matInput
                              type="text"
                              [(ngModel)]="FilterByBrand"
                            />
                          </mat-form-field>
                        </div>

                    </th>
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            matInput
                            type="text"
                            [(ngModel)]="FilterByTypeOfService"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody >
                  <tr
                  
                    *ngFor="
                      let serviceAdvisor of modalData[0]
                        | filterAdvisors
                          : FilterByName
                          : FilterByBrand
                          : FilterByTypeOfService :FilterByWorkshop
                        | slice : from : to;
                      let index = index
                    "
                  >
                    <td style="width: 13%; font-size: 16px; text-align: center">
                      {{ serviceAdvisor.advisorName }}
                    </td>
                    <td style="width: 15%; font-size: 16px; text-align: center">
                      <mat-slide-toggle
                      *ngIf="serviceAdvisor.isActive"
                      
                      [(ngModel)]="serviceAdvisor.isActive"
                      (toggleChange)="onToggleAdvisorActive(serviceAdvisor)"
                      
                    >
                      {{"Active" | translate | capitalize}}
                    </mat-slide-toggle>
                    <mat-slide-toggle
                    *ngIf="!serviceAdvisor.isActive"
                    
                    
                    [(ngModel)]="serviceAdvisor.isActive"
                    (toggleChange)="onToggleAdvisorActive(serviceAdvisor)"
                    
                  >
                    {{"Inactive" | translate | capitalize}}
                  </mat-slide-toggle>
                     
                    </td>
                    <td
                    style="width: 14%; font-size: 16px; text-align: center"
                    *ngIf="helperService.user.role.roleId === 4"
                    >
                  {{serviceAdvisor.workshopName}}
                  </td>
                  <td style="width: 14%; font-size: 16px; text-align: center">
                    
                    <ng-container
                    
                      *ngFor="
                        let brand of serviceAdvisor.brands;
                        let last = last
                        let i = index
                      "
                    >
                  <span *ngIf="brand.isActive">    {{brand.brandName}} </span> 
                    </ng-container>
                  </td>
                    <td style="width: 15%; font-size: 16px; text-align: center">
                      <p *ngFor="let service of serviceAdvisor.services | activeServices"
                      style="margin:0">{{
                        service.serviceName 
                      }}</p>
                    </td>
                    <td style="width: 16%">
                      <div class="grid-controls">
                        <button class="action-btn col-lg-3">
                          <i
                            class="material-icons-outlined"
                            [id]="'pencil-' + index"
                           
                            (click)="onEditInformationClick(serviceAdvisor)"
                            matTooltip="{{ 'EditInformation' | translate }}"
                          >edit
                          </i>
                        </button>

                        <button class="action-btn col-lg-3">
                          <i
                            class="material-icons-outlined"
                            [id]="'clock-' + index"
                          
                            (click)="onConfigureHoursClick(serviceAdvisor)"
                            matTooltip="{{ 'ConfigureSchedule' | translate }}"
                          >access_time
                          </i>
                        </button>

                        <button class="action-btn col-lg-3">
                          <i
                            class="material-icons-outlined"
                            [id]="'calendar-x-' + index"
                            (click)="onLockSettingsClick(serviceAdvisor)"
                            matTooltip="{{ 'ConfigureBlock' | translate }}"
                          >free_cancellation
                          </i>
                          
                        </button>

                        <button class="action-btn col-lg-3">
                          <i class="material-icons-outlined" (click)="onDeleteAdvisorClick(serviceAdvisor)"
                          [id]="'trash3-' + index"
                          matTooltip="{{ 'DeleteAdvisor' | translate }}">delete</i>
                         
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row advisor-grid-footer">
              <mat-divider></mat-divider>
            </div>
            <div class="row grid-pagination-container">
              <mat-paginator
                [length]="(modalData[0]| filterAdvisors: FilterByName : FilterByBrand: FilterByTypeOfService :FilterByWorkshop)?.length"
                [pageSize]="pagesize"
                [pageSizeOptions]="[4, 8, 16, 32]"
                aria-label="Select page"
                (page)="changePage($event)"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
          </div>
          
        </mat-card>
      </mat-card>
    </mat-card>
  </div>
</div>
